export default __webpack_public_path__ + "static/media/settings.2066a0a9.svg";